import { useContext } from "react";
import { useTranslation } from "react-i18next";
import SummarySection from "../../group_travel/components/Summary";
import BindQuoteStepNavigation from "../../group_travel/bind/BindQuoteStepNavigation";
import { BindContext } from "../BindQuote";

interface SummaryQuoteProps {
  onNext: VoidFunction | null;
  onPrevious: VoidFunction | null;
}

const QuoteSummary: React.FC<SummaryQuoteProps> = ({ onNext, onPrevious }) => {
  const { state } = useContext(BindContext);
  const { t } = useTranslation("pages", { keyPrefix: "groupPersonalAccident.newProduct.bind.navigation.button" });
  return (
    <div className="container-flow flex-grow">
      {state.quoteId && <SummarySection state={state} />}
      <BindQuoteStepNavigation nextButtonLabel={t("continueToBind")} backButtonLabel={t("goToListing")} onNext={onNext} onBack={onPrevious} />
    </div>
  );
};

export default QuoteSummary;
